import {
    RequestedCreateActiveIngredientActionCreator,
    SuccceededCreateActiveIngredientActionCreator,
    FailedCreateActiveIngredientActionCreator,
    RequestedUpdateActiveIngredientActionCreator,
    SuccceededUpdateActiveIngredientActionCreator,
    FailedUpdateActiveIngredientActionCreator,
    RequestedDeleteActiveIngredientActionCreator,
    SuccceededDeleteActiveIngredientActionCreator,
    FailedDeleteActiveIngredientActionCreator,
    SetActiveIngredientActionCreator,
    SetActiveIngredientsActionCreator
} from './types';
import {
    ACTIVE_INGREDIENT_CREATE_REQUESTED,
    ACTIVE_INGREDIENT_CREATE_SUCCEEDED,
    ACTIVE_INGREDIENT_CREATE_FAILED,
    ACTIVE_INGREDIENT_UPDATE_REQUESTED,
    ACTIVE_INGREDIENT_UPDATE_SUCCEEDED,
    ACTIVE_INGREDIENT_UPDATE_FAILED,
    ACTIVE_INGREDIENT_DELETE_REQUESTED,
    ACTIVE_INGREDIENT_DELETE_SUCCEEDED,
    ACTIVE_INGREDIENT_DELETE_FAILED,
    ACTIVE_INGREDIENT_SET,
    ACTIVE_INGREDIENTS_SET
} from './constants';

export const requestedCreateActiveIngredient: RequestedCreateActiveIngredientActionCreator = (
    activeIngredient
) => {
    return {
        type: ACTIVE_INGREDIENT_CREATE_REQUESTED,
        payload: activeIngredient
    };
};

export const succeededCreateActiveIngredient: SuccceededCreateActiveIngredientActionCreator = (
    response
) => {
    return {
        type: ACTIVE_INGREDIENT_CREATE_SUCCEEDED,
        payload: response
    };
};

export const failedCreateActiveIngredient: FailedCreateActiveIngredientActionCreator = (
    error
) => {
    return {
        type: ACTIVE_INGREDIENT_CREATE_FAILED,
        payload: error,
        error: true
    };
};

export const requestedUpdateActiveIngredient: RequestedUpdateActiveIngredientActionCreator = (
    activeIngredientId,
    activeIngredient
) => {
    return {
        type: ACTIVE_INGREDIENT_UPDATE_REQUESTED,
        payload: {
            activeIngredientId,
            activeIngredient
        }
    };
};

export const succeededUpdateActiveIngredient: SuccceededUpdateActiveIngredientActionCreator = (
    response
) => {
    return {
        type: ACTIVE_INGREDIENT_UPDATE_SUCCEEDED,
        payload: response
    };
};

export const failedUpdateActiveIngredient: FailedUpdateActiveIngredientActionCreator = (
    error
) => {
    return {
        type: ACTIVE_INGREDIENT_UPDATE_FAILED,
        payload: error,
        error: true
    };
};

export const requestedDeleteActiveIngredient: RequestedDeleteActiveIngredientActionCreator = (
    activeIngredientId
) => {
    return {
        type: ACTIVE_INGREDIENT_DELETE_REQUESTED,
        payload: {
            activeIngredientId
        }
    };
};

export const succeededDeleteActiveIngredient: SuccceededDeleteActiveIngredientActionCreator = (
    response
) => {
    return {
        type: ACTIVE_INGREDIENT_DELETE_SUCCEEDED,
        payload: response
    };
};

export const failedDeleteActiveIngredient: FailedDeleteActiveIngredientActionCreator = (
    error
) => {
    return {
        type: ACTIVE_INGREDIENT_DELETE_FAILED,
        payload: error,
        error: true
    };
};

export const setActiveIngredient: SetActiveIngredientActionCreator = (
    activeIngredient
) => {
    return {
        type: ACTIVE_INGREDIENT_SET,
        payload: { [activeIngredient.uuid]: activeIngredient }
    };
};

export const setActiveIngredients: SetActiveIngredientsActionCreator = (
    activeIngredients
) => {
    return {
        type: ACTIVE_INGREDIENTS_SET,
        payload: activeIngredients
    };
};
